<!-- 解锁接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/commonStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
      return {
        requestBody: {
          "parkCode": "2KKN885S",
          "channelCode": "AA123C",
          "newCarNo": "粤Y12345",
          "correctTime": "20200413112200"
        },
        responseCode:{"data":{},"message":"未找到停车记录","resultCode":905,"status":2},
        infoData: {
          explain: "第三方接入系统请求智慧停车开放平台对指定车场、通道的待进出记录进行车牌校正",
          t_url: this.commonUrls.test+"correctCarOnChannel",
          p_url: this.commonUrls.prod+"correctCarOnChannel",
          precondition: "无",
          fitSystem: "云停车场",
          pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
          Q_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
              { info1: 'channelCode', info2: '是', info3: 'String', info4: '通道自定义编码' },
              { info1: 'newCarNo', info2: '是', info3: 'String', info4: '校正后车牌' },
              { info1: 'correctTime', info2: '是', info3: 'String', info4: '校正时间，格式：yyyyMMddHHmmss' },
            ]
          }],
          R_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
            ]
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
            td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/parking/correctCarOnChannel.vue